<sg-borrower-entity-select
  class="sg-borrower-entity-select"
  [availabilitySplit]="availability"
  [disabled]="withFormControl.disabled"
  [session]="session"
  (selectionChange)="selectionChange.emit($event)"></sg-borrower-entity-select>
<sg-borrower-input
  class="sg-borrower-entity-units"
  [withFormControl]="withFormControl"
  [revertTooltipMsg]="revertTooltipMsg"
  [errorValidatorsMessages]="errorValidatorsMessages"
  (onBlurRow)="onBlurRow.next()"></sg-borrower-input>
